module.exports = __webpack_public_path__ + "img/avax.4cc54d1a.svg";